import { render, staticRenderFns } from "./EmployeeDetail.vue?vue&type=template&id=b61ba220&scoped=true"
import script from "./EmployeeDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeDetail.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EmployeeDetail.vue?vue&type=style&index=0&id=b61ba220&prod&scoped=true&lang=css"
import style1 from "./EmployeeDetail.vue?vue&type=style&index=1&id=b61ba220&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61ba220",
  null
  
)

export default component.exports